import React from "react";
import "./FrothyBackground.css";

const FrothyBackground = () => {
  return <div className="intro-frothy-background"></div>;
};

export default FrothyBackground;
